export default __webpack_public_path__ + "static/media/urgent_outreach.7f6e54fc.svg";